import { useState, useEffect } from "react";
import StudentDetailModel from "../Modals/StudentDetailModel";
import useModal from "../hooks/useModal";

function StudentChapter({
  completedChapter,
  allChapter,
  selectedUnit,
  studentForId,
}) {
  // TÜM HOOK'LAR KOŞULSUZ OLARAK EN ÜSTTE
  const { visable, Open, Close } = useModal();
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedUnitName, setSelectedUnitName] = useState(null);
  const [selectChapterForDetail, setSelectChapterForDetail] = useState(null);
  const [taskName, setTaskName] = useState("");
  // console.log(allChapter, "all cahter", completedChapter, "ilk değerler");
  // useEffect'i de en üste taşı
  useEffect(() => {
    // Burada selectedUnit kontrolü yapabiliriz
    if (selectedUnit && allChapter) {
      const alltChapterTask = allChapter.filter(
        (chapter) =>
          chapter.unites.toLowerCase() === selectedUnit.toLowerCase(),
      );
      if (alltChapterTask.length > 0) {
        setSelectChapterForDetail(alltChapterTask[0].unites);
      }
    }
  }, [selectedUnit, allChapter]); // selectedUnit değiştiğinde çalışsın

  //bölüm başlışıın düzenleme
  useEffect(() => {
    // Eğer selectedUnit yoksa veya null ise çalışma
    if (!selectedUnit) return;

    let words = ""; // Burada let kullanıyoruz çünkü değiştireceğiz.
    if (selectedUnit.includes("_")) {
      words = selectedUnit.split("_");
      const name = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1),
      );
      const TaskName = name.join(" ");
      setTaskName(TaskName);
    } else {
      const name = selectedUnit.charAt(0).toUpperCase() + selectedUnit.slice(1);
      setTaskName(name);
    }
  }, [selectedUnit]);
  // Koşullu return ifadesi hook'lardan SONRA
  if (!selectedUnit) return null;

  let alltChapterTask = [];
  let completedChapterTask = [];

  if (allChapter && completedChapter) {
    alltChapterTask = allChapter.filter(
      (chapter) => chapter.unites.toLowerCase() === selectedUnit.toLowerCase(),
    );
    completedChapterTask = completedChapter.filter(
      (chapter) => chapter.unit.toLowerCase() === selectedUnit.toLowerCase(),
    );
  }
  // console.log(alltChapterTask, completedChapterTask);
  const formatChapterName = (value) => {
    if (!value || typeof value !== "string") return "";

    const str = value;
    if (str.includes("_")) {
      const words = str.split("_");
      const capitalized = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1),
      );
      return capitalized.join(" ");
    } else {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  };

  const handleChapterDetail = (chapter) => {
    if (!chapter) return;

    setSelectedChapter(chapter);
    setSelectedUnitName(selectedUnit);
    Open("StudentDetailModel");
  };

  // Eğer bölüm yoksa kullanıcıya bilgi ver
  if (alltChapterTask.length === 0) {
    return (
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">
          {taskName} - Bölümler
        </h3>
        <div className="text-center p-8 bg-gray-50 rounded-lg">
          <p className="text-gray-500">Bu ünite için henüz bölüm eklenmemiş.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6">
      <h3 className="text-xl font-semibold mb-4 text-gray-800">
        {taskName} - Bölümler
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
        {alltChapterTask.map((item, index) => {
          const isCompleted = completedChapterTask.some(
            (completed) =>
              completed.chapter.toLowerCase() === item.chapter.toLowerCase(),
          );
          return (
            <div
              key={index}
              onClick={() => handleChapterDetail(item.chapter)}
              className={`p-4 rounded-lg shadow-md transition-all
                duration-300 hover:shadow-lg hover:bg-gray-200 cursor-pointer bg-gray-100`}
            >
              <div className="flex items-center justify-between ">
                <div className="flex-1">
                  <h4 className="font-medium text-gray-700 text-md">
                    {formatChapterName(item.chapter)}
                  </h4>
                  <hr className="border border-purple-500 w-28" />
                </div>

                <div>
                  {isCompleted ? (
                    <div key={index}>
                      {completedChapterTask.find(
                        (completed) =>
                          completed.chapter.toLowerCase() ===
                          item.chapter.toLowerCase(),
                      )?.completedChapter ? null : (
                        <p className="bg-blue-500 rounded-xl text-xs mx-1 py-1 px-1 text-white">
                          Homework
                        </p>
                      )}
                    </div>
                  ) : null}
                </div>
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    isCompleted ? "bg-green-500" : "bg-yellow-500"
                  }`}
                >
                  {isCompleted ? (
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <StudentDetailModel
        visable={visable.StudentDetailModel}
        Close={() => Close("StudentDetailModel")}
        unit={selectedUnitName}
        chapter={selectedChapter}
        selectChapter={selectChapterForDetail}
        studentForId={studentForId}
      />
    </div>
  );
}

export default StudentChapter;
